export default __webpack_public_path__ + "static/5-0810090fea2d06c2310bb281d798be9c.jpg";